import styled from 'styled-components';
import React from 'react';
import { clsx } from 'clsx';
import { get } from '../constants.js';
import sx from '../sx.js';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import classes from './Pagehead.module.css.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CSS_MODULES_FEATURE_FLAG = 'primer_react_css_modules_staff';

/**
 * @deprecated
 */
const StyledComponentPagehead = toggleStyledComponent(CSS_MODULES_FEATURE_FLAG, 'div', styled.div.withConfig({
  displayName: "Pagehead__StyledComponentPagehead",
  componentId: "sc-diawfz-0"
})(["position:relative;padding-top:", ";padding-bottom:", ";margin-bottom:", ";border-bottom:1px solid ", ";", ";"], get('space.4'), get('space.4'), get('space.4'), get('colors.border.default'), sx));
const Pagehead = ({
  className,
  ...rest
}) => {
  const enabled = useFeatureFlag(CSS_MODULES_FEATURE_FLAG);
  if (enabled) {
    return /*#__PURE__*/React.createElement(StyledComponentPagehead, _extends({
      className: clsx(classes.Pagehead, className)
    }, rest));
  }
  return /*#__PURE__*/React.createElement(StyledComponentPagehead, rest);
};
Pagehead.displayName = "Pagehead";

export { Pagehead as default };
